<template>
  <section
    id="objectives"
    class="objectives">
    <div class="container">
      <div class="column-holder">
        <div class="column bx-shadow">
          <div class="headings">
            <div class="image">
              <img
                src="@/../public/img/ico01.png"
                height="52"
                width="52"
                alt="image description">
            </div>
            <h2 class="h3">Testversion</h2>
          </div>
          <div class="content">
            <p>Probieren Sie unsere Testversion ohne Stammdaten aus: <a
              class="link"
              href="/test">Jetzt starten</a></p>
          </div>
        </div>
        <div class="column bx-shadow">
          <div class="headings">
            <div class="image">
              <img
                src="@/../public/img/ico02.png"
                height="51"
                width="51"
                alt="image description">
            </div>
            <h2 class="h3">Einfache Bedienung</h2>
          </div>
          <div class="content">
            <p>In nur 3 Schritten: Mitarbeiter und Arbeitstage anlegen, Ergebnis erhalten – <span class="text-bold">auch rückwirkend.</span></p>
          </div>
        </div>
        <div class="column bx-shadow">
          <div class="headings">
            <div class="image">
              <img
                src="@/../public/img/ico03.png"
                height="48"
                width="48"
                alt="image description">
            </div>
            <h2 class="h3">Nach gesetzlichen Vorschriften</h2>
          </div>
          <div class="content">
            <p>Immer aktuell, <span class="text-bold">bei jeder Überprüfung!</span> – Keine hohen Vertragsstrafen durch Zoll oder Lohnsteuerprüfung.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeObjectives'
}
</script>
